module.exports = __webpack_public_path__ + "img/p-trang.364888ca.png";